<div class="container">
  <div class="row">
    <div class="col-lg-3 col--flex">
      <firewall-shortcut-menu [subscription]="subscription()" [activities]="activities()" />
    </div>
    <div class="col-lg-9">
      <div class="card">
        <subscription-detail-header
          [subscription]="subscription()"
          [showReportIncidentButton]="isCurrentOrganisation()"
        />

        <div class="row">
          <div class="col-12 col-sm-7">
            <table class="table-properties table-properties--no-margin">
              <tr>
                <td>{{ "ServiceElement.Owner" | translate }}</td>
                <td>{{ owner() }}</td>
              </tr>
              <tr>
                <td>{{ "ServiceElement.OwnAlias" | translate }}</td>
                <td>
                  <alias-editor [customerDescription]="customerDescription()" [subscriptionId]="subscriptionId()" />
                </td>
              </tr>
              <tr>
                <td>{{ "ServiceElement.SURFnetDescription" | translate }}</td>
                <td>{{ description() }}</td>
              </tr>
              @if (hasReferences()) {
                <tr third-party-service-ids-row-content [references]="references()"></tr>
              }
              <tr>
                <td>{{ "ServiceElement.ServiceID" | translate }}</td>
                <td>
                  <service-id [subscriptionId]="subscriptionId()" />
                </td>
              </tr>
              <tr>
                <td>{{ "ServiceElement.ProductName" | translate }}</td>
                <td>{{ "ServiceElement.ProductName.SURFfirewall" | translate }}</td>
              </tr>
              <tr>
                <td>{{ "ServiceElement.ServiceSpeed" | translate }}</td>
                <td>{{ serviceSpeed() | service_speed }}</td>
              </tr>
            </table>
          </div>
          <div class="col-12 col-sm-5">
            <table class="table-properties table-properties--no-margin">
              <tr>
                <td>{{ "ServiceElement.FWASN" | translate }}</td>
                <td>{{ fwAsn() }}</td>
              </tr>
              <tr>
                <td>{{ "ServiceElement.AvailabilityZone" | translate }}</td>
                <td>{{ availabilityZone() }}</td>
              </tr>
              @if (isTerminated()) {
                <tr>
                  <td>{{ "ServiceElement.Status" | translate }}</td>
                  <td>{{ status() }}</td>
                </tr>
              }
              <tr>
                <td>{{ "ServiceElement.Start" | translate }}</td>
                <td>{{ startDate() | subscription_date }}</td>
              </tr>
              @if (isTerminated()) {
                <tr>
                  <td>{{ "ServiceElement.End" | translate }}</td>
                  <td>{{ endDate() | subscription_date }}</td>
                </tr>
              }
              <tr>
                <td>{{ "ServiceElement.Domain" | translate }}</td>
                <td>{{ domain() }}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>

  @if (isTerminated()) {
    <div class="hide-everything-after-this-div"></div>
  }

  <page-tab [tabconfig]="tabConfig()" [activeTab]="activeTab()" (activeTabEmitter)="tabChange.emit($event)"> </page-tab>

  @if (isGraphicViewTabActive()) {
    <div>
      <networkgraph [topology]="topology()" [subscription]="subscription()" #chart></networkgraph>
    </div>
    <!-- temporarily hide the systemStats until a solid influx deployment is in place -->
    <!-- } @else if (isSystemStatsTabActive()) {
    <div>
      <div>
        <system-stats [subscription]="subscription()"></system-stats>
        <traffic-line-chart [subjects]="chartSubjects()" />
      </div>
    </div> -->
  } @else {
    <div>
      <div class="section">
        @if (ipGateway(); as gateway) {
          <uplink-detail-container [subscription]="subscription()" [ipGateway]="gateway" />
        } @else {
          <empty-state
            [title]="
              'ServiceElement.EmptyState.Title'
                | translate: { product: ('ServiceElement.SURFinternetUplink' | translate) }
            "
            [icons]="['ip']"
          ></empty-state>
        }
      </div>
      <div class="section">
        <fw-detail-container [service]="subscription()" />
      </div>
      <traffic-line-chart [subjects]="chartSubjects()" />
    </div>
  }
</div>
